import { render, staticRenderFns } from "./ComprometimentoAnexoExcluir.vue?vue&type=template&id=482d48b0"
import script from "./ComprometimentoAnexoExcluir.vue?vue&type=script&lang=js"
export * from "./ComprometimentoAnexoExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports